
<div class="content-block">

    <!-- Content Header (Page header) -->
    
    <div class="content-header">
       <div class="container-fluid">
         <div class="row">
           <div class="col-sm-6">
             <h1 class="m-0 text-dark">Dipendenti</h1>
           </div><!-- /.col -->
           <div class="col-sm-6">
             <ol class="breadcrumb float-sm-right">
               <li class="breadcrumb-item"><a href="/home">Dashboard</a></li>
               <li class="breadcrumb-item">Dipendenti</li>
               <li class="breadcrumb-item active">Scheda</li>
             </ol>
           </div><!-- /.col -->
         </div><!-- /.row -->
       </div><!-- /.container-fluid -->
     </div>
     <!-- /.content-header -->
</div>

<div class="content-block">


    <section class="col-lg-12 ">

       <div class="card primary">
         <div class="card-header">
           <h3 class="card-title">
             <i class="fa fa-chart-pie mr-1"></i>
             Gestione dettagli operatori - dispositivi
           </h3>
           
         </div><!-- /.card-header -->
         <div class="card-body">
           
            <dx-data-grid
            [dataSource]="dataSource"
            [showBorders]="true"
            [focusedRowEnabled]="true"
            [focusedRowIndex]="0"
            [columnAutoWidth]="true"
            [columnHidingEnabled]="true">
            <dxo-group-panel [visible]="true"></dxo-group-panel>
            <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>
            
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
            <dxo-filter-row [visible]="true"></dxo-filter-row>

            <dxo-editing
                mode="popup"
                [allowAdding]="true"
                [allowUpdating]="true"
                [allowDeleting] ="true"
                [useIcons]="true">
                <dxo-texts confirmDeleteMessage="Sei sicuro di voler eliminare il dettaglio?"></dxo-texts>  
                <dxo-popup
                    title="Dettaglio"
                    [showTitle]="true"
                    [width]="700"
                    [height]="400">
                </dxo-popup>
                <dxo-form>
                    <dxi-item itemType="group" [colCount]="3" [colSpan]="2">
                        <dxi-item dataField="codcope"></dxi-item>
                        <dxi-item dataField="idDpi"></dxi-item>
                        <dxi-item dataField="taglia"></dxi-item>
                        <dxi-item
                            dataField="note"
                            editorType="dxTextArea"
                            [colSpan]="3"
                            [editorOptions]="{ height: 80 }">
                        </dxi-item>
                    </dxi-item>
                </dxo-form>
            </dxo-editing>
            <dxi-column type="buttons" [buttons]="['edit', 'delete']"></dxi-column>

            <dxi-column
                dataField="codcope"
                caption="Dipendente" 
                [groupIndex]="0">
                <dxo-lookup [dataSource]="listDip" valueExpr="codCope" displayExpr="nominativo" ></dxo-lookup>
            </dxi-column>   
            <dxi-column
                dataField="idDpi"
                caption="Articoli">
                <dxo-lookup [dataSource]="listArticoli" valueExpr="id" [displayExpr]="getArticoloDisplayExpr" ></dxo-lookup>
            </dxi-column>
            <dxi-column
                dataField="taglia">
            </dxi-column>   
            <dxi-column
                dataField="note"
                [width]="40+'%'" >
            </dxi-column>     
            
        </dx-data-grid>

         </div><!-- /.card-body -->
       </div>
       <!-- /.card -->

     </section>


<!--<h2 class="content-block">Tabella Dpi</h2>
   <div class="content-display">
       
   </div>-->
</div>



